import client_safety from "../images/ourEthos/client_safety.png";
import curated_experiences from "../images/ourEthos/exclusive_journeys.jpg";
import personalised_service from "../images/ourEthos/WL__personalised service.jpg";
import woman_empowerment from "../images/ourEthos/premium_experiences.png";

const data = [
  {
    icon: "curated_experiences",
    heading: "Exclusive Journeys",
    description: "Discover hidden treasures through the lens of safety, authenticity, and meaningful connections.",
    image: curated_experiences,
  },
  {
    icon: "client_safety",
    heading: "Client Safety",
    description:
      "Prioritizing the safety and well-being of our clients, ensuring secure and comfortable journeys.",
    image: client_safety,
  },
  {
    icon: "woman_empowerment",
    heading: "Premium Experiences",
    description: "Combine luxury with cultural immersion, ensuring every step of your journey tells a story worth sharing.",
    image: woman_empowerment,
  },
  {
    icon: "personalised_service",
    heading: "Customized Service",
    description: "We meticulously craft each itinerary to reflect your individual tastes, interests, and dreams—turning travel into a truly personal experience.",
    image: personalised_service,
  },
];

export default data;
